import * as LiveSessionEvents from "./liveSessionEvents";

export const GET_ACTIVE_LIVE_SESSION_BY_COURSE = "GET_ACTIVE_LIVE_SESSION_BY_COURSE";
export const GET_ACTIVE_LIVE_SESSION_BY_COURSE_SUCCESS =
  "GET_ACTIVE_LIVE_SESSION_BY_COURSE_SUCCESS";
export const GET_ACTIVE_LIVE_SESSION_BY_COURSE_ERROR = "GET_ACTIVE_LIVE_SESSION_BY_COURSE_ERROR";
export const SET_LIVE_SESSION_INITIAL_STATE = "SET_LIVE_SESSION_INITIAL_STATE";
export const SET_LOCAL_LIVE_SESSION_STREAMING = "SET_LOCAL_LIVE_SESSION_STREAMING";
export const GET_LIVE_SESSIONS_LIST = "GET_LIVE_SESSIONS_LIST";
export const GET_LIVE_SESSIONS_LIST_SUCCESS = "GET_LIVE_SESSIONS_LIST_SUCCESS";
export const GET_LIVE_SESSIONS_LIST_ERROR = "GET_LIVE_SESSIONS_LIST_ERROR";
export const GET_LIVE_SESSION = "GET_LIVE_SESSION";
export const GET_LIVE_SESSION_SUCCESS = "GET_LIVE_SESSION_SUCCESS";
export const GET_LIVE_SESSION_ERROR = "GET_LIVE_SESSION_ERROR";
export const CREATE_LIVE_SESSION = "CREATE_LIVE_SESSION";
export const CREATE_LIVE_SESSION_SUCCESS = "CREATE_LIVE_SESSION_SUCCESS";
export const CREATE_LIVE_SESSION_ERROR = "CREATE_LIVE_SESSION_ERROR";
export const UPDATE_LIVE_SESSION = "UPDATE_LIVE_SESSION";
export const UPDATE_LIVE_SESSION_SUCCESS = "UPDATE_LIVE_SESSION_SUCCESS";
export const UPDATE_LIVE_SESSION_ERROR = "UPDATE_LIVE_SESSION_ERROR";

export const SET_LIVE_SESSION_STATE = "SET_LIVE_SESSION_STATE";

const SET_LIVE_SESSION_STATE_SUCCESS_PREFIX = "SET_LIVE_SESSION_STATE_SUCCESS_";
const SET_LIVE_SESSION_STATE_ERROR_PREFIX = "SET_LIVE_SESSION_STATE_ERROR_";
const SET_LIVE_SESSION_STATE_SUCCESS = {};
const SET_LIVE_SESSION_STATE_ERROR = {};

Object.keys(LiveSessionEvents).forEach((event) => {
  SET_LIVE_SESSION_STATE_SUCCESS[
    LiveSessionEvents[event]
  ] = `${SET_LIVE_SESSION_STATE_SUCCESS_PREFIX}${LiveSessionEvents[event]}`;
  SET_LIVE_SESSION_STATE_ERROR[
    LiveSessionEvents[event]
  ] = `${SET_LIVE_SESSION_STATE_ERROR_PREFIX}${LiveSessionEvents[event]}`;
});

export { SET_LIVE_SESSION_STATE_SUCCESS, SET_LIVE_SESSION_STATE_ERROR };
